import React, { useEffect, useState } from "react";
import { FiArrowUp, FiArrowDown } from "react-icons/fi";
import { documentData } from "./DocumentsModal";
import DocumentsModal from "./DocumentsModal";
import { ShowPDF } from "./CommonUtilities/CommonFunctions/CommonFunction";
import { config } from "./CommonUtilities/CommonUrl/CommonUrls";
import axios from "axios";
import moment from "moment";
import { Modal, Button, Table, Spinner } from "react-bootstrap";
import { BsDownload } from "react-icons/bs";
import { downloadPDF } from "./CommonUtilities/CommonFileUpload/ViewImage";

function Notifications(props) {
  const { handledCShow, handleGoClose } = props;
  const otherNotifications = [
    // ...(documentData.tet_hallticket || []),
    // ...(documentData.tet_go || []),
    // ...(documentData.tet_press_note || []),
    // ...(documentData.tet_notification || []),
    // ...(documentData.tet_schedule || []),
    // ...(documentData.tet_syllabus || []),
    // ...(documentData.tet_bullitin || []),
    ...(documentData.spl_tet_aug_go || []),
    ...(documentData.spl_tet_press_note || []),
    ...(documentData.spl_tet_notification || []),
    ...(documentData.spl_tet_schedule || []),
    ...(documentData.spl_tet_bulletien || []),
    ...(documentData.spl_tet_faqs || []),
  ];

  const [notifications, setNotifications] = useState(otherNotifications);
  useEffect(() => {
    const interval = setInterval(() => {
      setNotifications((prev) => {
        const updated = [...prev];
        updated.push(updated.shift());
        return updated;
      });
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  const moveListUp = () => {
    setNotifications((prev) => {
      const updated = [...prev];
      updated.push(updated.shift());
      return updated;
    });
  };
  const moveListDown = () => {
    setNotifications((prev) => {
      const updated = [...prev];
      updated.unshift(updated.pop());
      return updated;
    });
  };
  const [documentModal, setDocumentModal] = useState({
    show: false, title: "", data: [],
  });

  const [loading, setLoading] = useState(false);

  const openDocumentModal = (title, data) => {
    setDocumentModal({ show: true, title, data });
  };

  const closeDocumentModal = () => {
    setDocumentModal((prev) => ({ ...prev, show: false }));
  };

  const handleManualItemClick = (item) => {
    if (item.type === "document") {
      ShowPDF(item.url);
    } else if (item.type === "video") {
      window.open(item.url, "_blank");
    }
  };
  const fetchAnswerKeys = () => {
    setLoading(true);
    const Url = config.url.DSC_Read_URL + "dsc-public/tet-paperwise-consolidated-key-path-details";
    axios.get(Url).then((res) => {
      if (res?.data?.status === true) {
        const keyData = res?.data?.data || [];
        const filteredKeyData = keyData?.filter((val) => val?.consolidated_key_path);
        const formattedKeys = filteredKeyData.map((val) => ({
          name: `${val?.post_name}-${val?.med_name}-${moment(val?.exam_dt).format(
            "DD-MM-YYYY"
          )} Shift ${val?.exam_shift}`,
          c_key: val?.consolidated_key_path,
          f_key: val?.final_key_path,
        }));
        openDocumentModal("APTET-2025 Answer Keys", formattedKeys);
      }
      setLoading(false);
    })
      .catch(() => setLoading(false));
  };
  const showFinalKeyColumn = documentModal?.data?.some(
    (item) => item?.f_key
  );
  return (
    <div className="notifications-all">
      <h3>Notifications</h3>
      <ul>
        {/* <li  onClick={(e) => {  e.preventDefault();
                   handledCShow();
                  }}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                     e.preventDefault(); handledCShow();
                  }
                }}>
  <a href="#"
   
  ><img
        src="/img/new2.gif"
        style={{ height: "30px" }}
        className="img-fluid"
        alt="new"
      />
      <span className="text-danger"> APTET MARKS MEMO Released </span>
   
  </a>
</li>*/}
        <li
        //    onClick={(e) => {
        //   e.preventDefault();
        //   fetchAnswerKeys();
        // }}
        >
          {/* <a href={process.env.PUBLIC_URL + "/DSC-PDF/Syllabus-2026/Special Education DSC - 2026.pdf"} target="_">
  <img
        src="/img/new2.gif"
        style={{ height: "30px" }}
        className="img-fluid"
        alt="new"
      />
      <span className="text-danger"> Special Education DSC Syllabus - 2026 </span>
  
  </a> */}


        </li>
        {notifications?.map((item, index) => (
          <li key={index}>
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                window.open(item.url, "_blank");
              }}
            >
              {item.name}
            </a>
          </li>
        ))}
      </ul>
      <div className="d-flex justify-content-end gap-2 mt-2">
        <button onClick={moveListUp}>
          <FiArrowUp className="notific-arrow" />
        </button>
        <button onClick={moveListDown}>
          <FiArrowDown className="notific-arrow" />
        </button>
      </div>
      <Modal show={documentModal.show} onHide={closeDocumentModal} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>{documentModal.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {loading && (
            <div className="fp-container">
              <Spinner animation="border" variant="info" className="fp-loader" />
            </div>)}
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>S.No.</th>
                <th>Name</th>
                <th>Initial Key</th>
                {showFinalKeyColumn && <th>Final Key</th>}
              </tr>
            </thead>
            <tbody>
              {documentModal?.data.map((item, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{item?.name}</td>
                  <td>
                    <button type="button"
                      className="btn btn-primary ms-2 p-2 pt-1"
                      disabled={loading}
                      onClick={() => {
                        downloadPDF(item?.c_key, setLoading);
                      }}
                    >
                      <BsDownload className="me-1" />
                    </button>
                  </td>
                  {showFinalKeyColumn && (
                    <td>
                      {item?.f_key ? (
                        <button
                          type="button"
                          className="btn btn-primary ms-2 p-2 pt-1"
                          onClick={() => downloadPDF(item.f_key, setLoading)}
                        >
                          <BsDownload className="me-1" />
                        </button>
                      ) : (
                        "-"
                      )}
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          </Table>

        </Modal.Body>
      </Modal>
    </div>
  );
}

export default Notifications;
